@if( info(); as channel ){
<div class="info">
	<span class="name">{{ channel.name }}</span>
	<span class="description" [class.empty]="!channel.description">{{ channel.description || 'No Description' }}</span>

	<button *ngIf="!core.getChannelAction( channel, 'B' )" class="enter" (click)="core.setChannel( channel )">Enter Channel</button>
</div>
}
